<template>
	<div class="info-item">
		<div style="padding-bottom: 5px;display: flex;align-items: center;">
			<el-divider direction="vertical"></el-divider>
			<span>{{title}}</span>
		</div>
		<div class="form-box" v-if="form">
            <el-table :data="form" border size="mini" :header-cell-style="headerCellStyle">
				<el-table-column prop="bankNumber" label="银行账号" :show-overflow-tooltip="true" > </el-table-column>
				<el-table-column prop="bankGjCode" label="银行国家代码" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="name" label="银行名称" :show-overflow-tooltip="true" > </el-table-column>
				<el-table-column prop="bankLineNum" label="银行行号" :show-overflow-tooltip="true" > </el-table-column>
				<el-table-column prop="khhName" label="开户行名称" :show-overflow-tooltip="true" width="120"> </el-table-column>
				<el-table-column prop="accountName" label="账户名称" :show-overflow-tooltip="true"> </el-table-column>
				<el-table-column prop="isMainNum" label="是否主账号" :formatter="formatIsMainNum"> </el-table-column>
			</el-table>
		</div>
		<div v-else class="no-info-box">请补充相关信息</div>
	</div>
</template>

<script>
	export default {
		name: "ShowBankInfo",
		computed: {
			currencyInfo:function(){
				return this.$store.getters['app/currencyInfo'];
			},
		},
		props:['title','form'],
		data() {
			return {
				imgHost:process.env.VUE_APP_BASE_API,
				tableData: [],
			};
		},
		mounted() {
		},
		methods: {
            formatIsMainNum: function(row) {
				return row.isMainNum == 0 ? '是' : '否';
			},
		}
	};
</script>
<style scoped="scoped">
</style>